//@ts-check
import request from '../request';
/**
 * Get project by name
 * @param {string} name
 * @return {Promise<import("./types").Project>}
 */

var getProjectByName = function getProjectByName(name) {
  return request({
    url: '/backend/communications',
    query: {
      name: name
    }
  });
};

export default {
  getProjectByName: getProjectByName
};